import { Component } from "../ecs";
import { EditableComponent } from "../editor";
/**
 * A component for 2d spatial manipulation
 */
@EditableComponent
export class DebugComponent implements Component {}
